import { getStaticAsset } from "core/model/config";
import { useTranslations } from "translations";
import { InfoScreen } from "./index";

export function LoginMailSuccess() {
  const translations = useTranslations();

  return (
    <InfoScreen
      image={getStaticAsset("admissions-mail-sent.svg")}
      imageAlt={
        translations.careproviderApp.recareAdmissionsForm
          .emailSubmittedSuccessfully.altTextImage
      }
      pageTitle={
        translations.careproviderApp.recareAdmissionsForm.pageTitles
          .pageEmailSuccessfullySubmitted
      }
      paragraphOne={
        translations.careproviderApp.recareAdmissionsForm
          .emailSubmittedSuccessfully.paragraphOne
      }
      paragraphTwo={
        translations.careproviderApp.recareAdmissionsForm
          .emailSubmittedSuccessfully.paragraphTwo
      }
      title={
        translations.careproviderApp.recareAdmissionsForm
          .emailSubmittedSuccessfully.title
      }
    />
  );
}
